export default __webpack_public_path__ + "c3f0185a850cd2d50a06a1707cade801.png";